import { BCMSDate, useBCMSModal, useModel } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from "components/custom-ui/DateSelect";
import { FormContainer, FormRowView } from "components/shared";
import { UITextInput } from "components/ui";
import React, { useEffect, useState } from "react";

/**
 * @function OneTimeACHFormSection
 * @param {STRING} secCode - Sets the ACH sec code text. 
 * @param {STRING} effectiveDate - Sets the ACH effective date. 
 * @return {React.Component}
 * @exported true
 * @description The is the one time ACH form section for OneTimeACHPaymentPage
 */
export default function OneTimeACHFormSection(props) {
    const { branding } = useModel() ?? {};
    const { options } = branding ?? {};
    const ui = props.ui ?? {};
    const data = props.data ?? {};
    const action = props.action ?? {};
    const onChangeDataProp = action.onChangeDataProp ?? (() => {});
    const onChangeUIProp = action.onChangeUIProp ?? (() => {});
    const showSecCode = ui.showSecCode.isActive ?? false;
    const showOneTimeACHModal = ui.showOneTimeACHModal.isActive ?? true;
    const oneTimeACHPayment = data.oneTimeACHPayment ?? {};
    const companyAccounts = data.companyAccounts ?? [];
    const scheduleSelectIsActive = ui.scheduleSelectIsActive.isActive ?? false;
    const effectiveDateSelectIsActive = ui.effectiveDateSelectIsActive.isActive ?? false;
    const companySelectIsActive = ui.companySelectIsActive.isActive ?? false;
    
    const [secCode,setSecCode] = useState(undefined);
    const [transactionType,setTransactionType] = useState(undefined);
    const effectiveDate = props.effectiveDate ?? BCMSDate.init().offset(1).format("m/d/Y");
    const { close, open } = useBCMSModal();
    const propChangesToListenTo = [ secCode, transactionType, showOneTimeACHModal, showSecCode, JSON.stringify(oneTimeACHPayment) ];
    const hasOneTimeSameDay = options.onetimeach_same_day_abi22 === "true";
    const hasImmediateOption = options.onetimeach_immediate_abi22 === "true";

    // Only business days after today are enabled.
    const disableDay = date => {
        const tomorrow = BCMSDate.init();
        tomorrow.offset(1);
        let disabled = date.isBefore(tomorrow);
        if(date.isWeekend()) disabled = true;
        return disabled;
    };
    
    let effectiveDateLabel = "Effective Date";
    if(oneTimeACHPayment.schedule === "Future Dated") effectiveDateLabel = "* Effective Date";

    const companyAccountRows = companyAccounts.reduce((acc, item) => {
        const accountName = `${ item.nickname } - ${ item.number }`;
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.id } dataPoint={ `Company_Account_Option_${ item.id }` }>{ accountName } </CustomSelectItem>
        );
        return acc;
    }, []);

    useEffect(() => {
        if(showOneTimeACHModal) {
            open("OneTimeACHModal", { data, ui, oneTimeACHPayment, onChangeDataProp, onChangeUIProp });
        } else {
            close("OneTimeACHModal");
        }
    }, propChangesToListenTo);

    return (
        <div className="one-time-ach-payment-section one-time-ach-form-section">
           
            <FormContainer className="small-form-width">
                <FormRowView text="SEC Code">
                { showSecCode && 
                    <p className="form-detail-text sec-code-text">
                        <span>{ oneTimeACHPayment.secCode }</span>
                    </p>
}
                </FormRowView>
                <FormRowView text="* Schedule">
                    <CustomSelect active={ scheduleSelectIsActive } dataPoint={ `One_Time_ACH_Form_Schedule_Select` } value={ oneTimeACHPayment.scheduleType } onChange={ onChangeDataProp("scheduleType") }>
                        { hasImmediateOption && <CustomSelectItem value="immediate" dataPoint={ `One_Time_ACH_Form_Schedule_Option_Immediate` }>Immediate</CustomSelectItem> }
                        { hasOneTimeSameDay && <CustomSelectItem value="same day" dataPoint={ `One_Time_ACH_Form_Schedule_Option_Same_Day` }>Same-Day</CustomSelectItem> }
                        <CustomSelectItem value="future dated" dataPoint={ `One_Time_ACH_Form_Schedule_Option_Future_Dated` }>Future-Dated</CustomSelectItem>
                    </CustomSelect>  
                </FormRowView>
                <FormRowView text={ effectiveDateLabel }>
                    {/* Effective date text is shown if "Immediate" or "Same-Day" is selected */}
                    { (oneTimeACHPayment.scheduleType === "immediate" || oneTimeACHPayment.scheduleType === "same day") &&
                    <p className="form-detail-text effective-date-text">
                        <span>{ oneTimeACHPayment.effectiveDate.format("m/d/Y") }</span>
                    </p>
                    }
                    {/* DateSelect shown if "Future Dated" is selected */}
                    { oneTimeACHPayment.scheduleType === "future dated" &&
                        <DateSelect active={ effectiveDateSelectIsActive } value={ oneTimeACHPayment.effectiveDate } 
                        dataPoint={ `One_Time_ACH_Form_Effective_Date_Select` } disableDay={ disableDay } onChange={ onChangeDataProp("effectiveDate") } />
                    }
                </FormRowView>
                <FormRowView text="* Company Entry Description">
                    <UITextInput value={ oneTimeACHPayment.companyEntryDescription } dataPoint={ `One_Time_ACH_Form_Company_Entry_Description_Input` }
                    onChange={ onChangeDataProp("companyEntryDescription") } />
                </FormRowView>
                <FormRowView text="* Company">
                <CustomSelect active={ companySelectIsActive } value={ oneTimeACHPayment.company ? oneTimeACHPayment.company.id : ""  }
                dataPoint={ `One_Time_ACH_Form_Company_Select` }
                onChange={ onChangeDataProp("company") }>
                    { companyAccountRows }
                </CustomSelect>   
                </FormRowView>
            </FormContainer>

        </div>
    )
}